import {
  AccountCardIcon,
  IAccountCardSquareTile,
  TileStatus,
  VxlSideBySideTile,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { AccountIconType } from 'shared/components/vxl/AccountIcon/AccountIcon.helpers';
import { AccountCardSquareProps } from 'shared/components/vxl/cards/AccountCardSquare/AccountCardSquare';
import { propsFromTag } from 'shared/components/vxl/Tag/Tag.helpers';
import { SideBySideCardGroupProps } from 'shared/containers/vxl/groups/SideBySideCardGroup/SideBySideCardGroup';
import { VXLGroup, VXLGroupId } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';
import { Maybe } from 'shared/utils/types';

interface VXLSideBySideCardGroupNode extends VXLGroup {
  name: VXLGroupId.SIDE_BY_SIDE_CARD_GROUP;
  props: SideBySideCardGroupProps;
}

const mapAccountIcon = (icon: AccountCardIcon): AccountIconType => {
  switch (icon) {
    case AccountCardIcon.Advance:
      return AccountIconType.Advance;
    case AccountCardIcon.Vloc:
      return AccountIconType.LineOfCredit;
    default:
      return AccountIconType.Unknown;
  }
};

const vxlSideBySideTile = (
  tile: VxlSideBySideTile,
  { navigateToRoute }: HomeCardDependencies,
): Maybe<VXLSideBySideCardGroupNode> => {
  if (tile.status !== TileStatus.Loaded || !tile.tiles.length) {
    return null;
  }

  const cards: AccountCardSquareProps[] = tile.tiles
    .map((tile) => {
      if (tile.status !== TileStatus.Loaded) {
        return null;
      }

      const card = (tile as IAccountCardSquareTile)?.card;
      if (!card || card.__typename !== 'VXLAccountCardSquare') {
        return null;
      }

      const {
        amountText,
        bodyText,
        captionText,
        isDisabled,
        showPlusIcon,
        tag,
        titleText,
        onPress,
        icon,
      } = card;

      const onCardPress: Maybe<() => void> = isNotNil(onPress)
        ? () => {
            navigateToRoute(onPress);
          }
        : () => {};

      const props: AccountCardSquareProps = {
        accountIconProps: {
          product: mapAccountIcon(icon),
        },
        amountText: amountText,
        bodyText: bodyText,
        captionText: captionText,
        isDisabled: isDisabled ?? false,
        showPlusIcon: showPlusIcon,
        tagProps: propsFromTag(tag),
        titleText: titleText,
        onCardPress,
      };

      return props;
    })
    .filter(isNotNil)
    .slice(0, 2);

  return {
    id: tile.id,
    name: VXLGroupId.SIDE_BY_SIDE_CARD_GROUP,
    props: {
      cards,
    },
  };
};

export default vxlSideBySideTile;
